'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
class ForgottenPasswordPage extends _react.Component {
  state = {
    status_messages: {}
  };
  componentWillMount() {
    const component = this,
      props = this.props,
      state = this.state;
    let token = document.location.search.split('token=');
    if (!token[1]) {
      return component.setState({
        invalid: true
      });
    }
    token = token[1].split('&')[0];
    component.setState({
      invalid: false,
      token: token
    });
    qwest.post('/token/verify-password-recovery-token', {
      token: token
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  }
  handleChange = _ref => {
    let {
      e,
      value,
      name
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  requestPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.password !== state.password_confirmation) {
      return component.setState({
        error: 'Les champs doivent concorder.'
      });
    }
    component.setState({
      loading: true
    });
    qwest.post('/user/new-password', {
      password: state.password,
      token: state.token
    }).then(function (xhr, response) {
      component.setState({
        info: 'Votre mot de passe a été modifié avec succès, ' + 'vous pouvez dès maintenant l\'utiliser pour vous connecter.',
        loading: false,
        roles: response.roles
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const message = (0, _getFormStatus.default)(state);
    let loader;
    if (state.loading === true) {
      loader = /*#__PURE__*/_react.default.createElement(_Loader.default, {
        className: "c-loader",
        bemit: ['white', 'bg-primary']
      });
    }
    let submit;
    if (!state.info && !state.invalid) {
      submit = /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: component.requestPassword
      }, "Valider", loader));
    } else if (!state.invalid) {
      let link;
      if (state.roles && (state.roles.includes('admin') || state.roles.includes('agent'))) {
        link = (0, _Routes.URL)('Home', _Routes.front_urls);
      } else {
        link = (0, _Routes.URL)('Home', _Routes.front_urls);
      }
      submit = /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "secondary",
        size: "small",
        href: link,
        component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
      }, "Page de connexion", loader));
    }
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, props, /*#__PURE__*/_react.default.createElement("div", {
      className: "password-recovery-page"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content",
      style: {
        width: '450px',
        maxWidth: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-text-center u-margin-bottom-30"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "auth-logo-link",
      href: (0, _Routes.URL)('Home', _Routes.front_urls)
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    }))), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['password'],
      name: "password",
      type: "password",
      label: "Nouveau mot de passe",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['password_confirmation'],
      name: "password_confirmation",
      type: "password",
      label: "Confirmation de mot de passe",
      status: state.status_messages
    }), message, submit)));
    return output;
  }
}
exports.default = ForgottenPasswordPage;
